import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiGetCareerStats = (type, funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: `/api/insights/${type}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiGetCareerStats"),
  })
}
